import { render, staticRenderFns } from "./AddnewSubjective.vue?vue&type=template&id=156539e8&scoped=true"
import script from "./AddnewSubjective.vue?vue&type=script&lang=js"
export * from "./AddnewSubjective.vue?vue&type=script&lang=js"
import style0 from "./AddnewSubjective.vue?vue&type=style&index=0&id=156539e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156539e8",
  null
  
)

export default component.exports